import { connect } from 'react-redux'
import {
  setLayoutHeaderHeight,
  setLayoutFlavour,
  setLayoutState,
  setLegislationAct,
  setQASectionId,
  setWindowSize
} from 'redux/actions'
import LayoutComponent from 'components/LayoutComponent'

const mapStateToProps = (state) => ({
  isNavigationVisible: state.layout.isNavigationVisible,
  fullscreenOverlay: state.layout.fullscreenOverlay,
  browser: state.layout.browser,
  controller: state.layout.controller,
  headerHeight: state.layout.headerHeight,
  roles: state.user.roles,
  isLogged: state.user.isLogged,
  availableAol: state.aol.availableAol
})

const mapDispatchToProps = dispatch => ({
  setLayoutHeaderHeight: headerHeight => dispatch(setLayoutHeaderHeight(headerHeight)),
  setLayoutState: (props) => dispatch(setLayoutState(props)),
  setLayoutFlavour: flavour => dispatch(setLayoutFlavour(flavour)),
  setWindowSize: props => dispatch(setWindowSize(props)),
  setLegislationAct: act => dispatch(setLegislationAct(act)),
  setQASectionId: sectionId => dispatch(setQASectionId(sectionId))
})

export default connect(mapStateToProps, mapDispatchToProps)(LayoutComponent)
